import axios from '../../utils/axios';


// A mock function to mimic making an async request for data
export async function getPosts({filter,sort}) {

  console.log('first', filter,sort);
  let queryString = "";

 

  if (filter == "Saved") {

    
      queryString += `isSaved=${true}`;
  }




try {
  const posts = await axios.get(`/blogs?${queryString}`);

  let filterPost = await posts?.data?.map(post => ({...post,isLiked: post?.isLiked || false}))
  if (sort == "most_liked") {

    console.log('sort:most_liked', sort)

    filterPost = await filterPost.sort((a,b)=>(b?.likes   -  a?.likes  ));

    return filterPost;
  }
  if (sort == "newest") {

    function dateComparison(a, b) {
      const date1 = new Date(a?.createdAt)
      const date2 = new Date(b?.createdAt)
      
      return   date2 - date1;
  }
  
    filterPost = await  filterPost.sort(dateComparison);

    return filterPost;
  }

  return filterPost
} catch (error) {
  return error
}




  
  }
  
  export function SavedSinglePost(post) {
// const likeNumber = post?.isLiked?.toString() =="false" ? post?.likes + 1  : post?.likes -  1 

    const update = post?.updateItem ==="isLiked" ? {...post,   likes:post?.likes + 1 } : {...post,isSaved :  !post?.isSaved}
    // const 
    return axios.patch(`/blogs/${post.id}`,update)
  }
  